// extracted by mini-css-extract-plugin
module.exports = {"sky":"HarmoniaSquare_sky__2e7Se","yellow":"HarmoniaSquare_yellow__1fqjs","lightYellow":"HarmoniaSquare_lightYellow__2YBGb"};